import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Verified, Crown, Globe2, Building2, ArrowRight } from "lucide-react";

export default function ExchangeMembers() {
  const [members, setMembers] = useState([]);

  useEffect(() => { api.get("/exchange/members").then(r => setMembers(r.data)); }, []);

  const regions = [...new Set(members.map(m => m.region))];

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16" data-testid="exchange-members">
      <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706]">// Member Directory</div>
      <h1 className="display-black text-5xl lg:text-6xl uppercase text-[#064E3B] mt-3 tracking-tighter">Verified operators.</h1>
      <p className="text-gray-700 mt-3 max-w-2xl">
        {members.length} principals. {regions.length} regions. Every member is identity-verified before access.
      </p>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-300 border border-gray-300">
        {members.map(m => (
          <Link key={m.id} to={`/exchange/member/${m.handle}`} className="bento-card p-7 flex flex-col gap-3" data-testid={`member-${m.handle}`}>
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 text-white flex items-center justify-center font-bold text-lg shrink-0"
                style={{ background: `hsl(${(m.avatar_seed || m.name).charCodeAt(0) * 5 % 360}, 35%, 22%)` }}>
                {m.name.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <div className="display-black text-lg uppercase text-[#064E3B] flex items-center gap-2 leading-tight">
                  {m.name}
                  {m.verified && <Verified className="w-4 h-4 text-[#064E3B]" />}
                  {m.premium && <Crown className="w-4 h-4 text-[#FACC15]" />}
                </div>
                <div className="text-sm text-gray-700 mt-1">{m.title}</div>
                <div className="mono text-[10px] tracking-wider text-gray-500 uppercase mt-1 flex items-center gap-1.5">
                  <Building2 className="w-3 h-3" /> {m.company}
                </div>
                <div className="mono text-[10px] tracking-wider text-gray-500 uppercase flex items-center gap-1.5">
                  <Globe2 className="w-3 h-3" /> {m.location}
                </div>
              </div>
            </div>
            <p className="text-sm text-gray-700 line-clamp-3">{m.bio}</p>
            <div className="flex items-center justify-between pt-3 border-t border-gray-200">
              <div className="mono text-[10px] tracking-wider text-[#D97706] uppercase">{m.deals_closed} deals · ${m.deal_volume_m}M</div>
              <ArrowRight className="w-4 h-4 text-gray-400" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
